module.exports = __webpack_public_path__ + "media/images/pic/saska/elastic-fb860f629db1eb4364f41005821a41b4.svg";